<div id="page-wrapper">
    <app-menu-3 [menuConfig]="menuConfig"></app-menu-3>
    <div id="content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>
